module.exports = __webpack_public_path__ + "static/Jenna-2c515223de3ababb52b32c78c891d19b.png";